import { render } from "./CheckCouponCodeTab.vue?vue&type=template&id=48592c98"
import script from "./CheckCouponCodeTab.vue?vue&type=script&lang=js"
export * from "./CheckCouponCodeTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__